export enum AttendanceActions {
  Reset = "reset",
  FetchAttendanceList = "fetchAttendanceList",
  FetchCourseAttendanceList = "fetchCourseAttendanceList",
  FetchDayList = "fetchDayList",
  PostAttendance = "postAttendance",
  UpdateCurrentDay = "updateCurrentDay",
}
